import { EMPTY_STRING } from '@shared/models/strings.constants';
import { abbrevNumber } from '@miq/utils';
import * as L from 'leaflet';
/*
 * L2-R6: MapIcon / PinPadding / IconGenerator moved to @miq/shared-models
 * (maps/map-icon.enum.ts) so a consumer that needs only the enum names no longer pulls this
 * module — and with it `leaflet` — into its chunk. Re-exported here for the host callers that
 * import them alongside svgIconMaker / toggleIcon.
 */
export { MapIcon, PinPadding } from '@miq/shared-models';
export type { IconGenerator } from '@miq/shared-models';
import { MapIcon, pinSvg } from '@miq/shared-models';
/*
 * L2-S12: the five SVG template builders, their colour constants and `iconMap` were byte-moved to
 * @miq/shared-models (maps/pin-svg.ts) so the reports remote can draw the same pins without
 * importing host code. They are re-exported here under their original names: every host caller and
 * this file's spec keep importing them from this path, and there is still exactly ONE copy of the
 * strings. What stays below is the only part that needs leaflet — turning a pin string into an
 * `L.icon` — plus `toggleIcon`, which is host-only marker mutation.
 */
export {
  buildSvgIcon,
  reportIcon,
  reportCBREGreenIcon,
  reportSingleIcon,
  clipboardMapIcon,
  iconMap,
} from '@miq/shared-models';
export { pinSvg };
export const svgIconMaker = (svgData, options?) => {
  const fn = pinSvg(svgData);
  return svgIconFactory(fn, { ...options });
};
/**
 * Exported for `esri-map.helpers.ts#buildMarkers`, which now receives an already-built pin string
 * from `buildPinSpecs` and needs this exact data-URL construction to wrap it.
 */
export const svgIconFactory = (svgData, { width = 58, height = 40 }) =>
  L.icon({
    iconUrl: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgData)}`,
    iconSize: [width, height],
  });
export const toggleIcon = (marker, clipboardMarkers) => {
  const miqData = (marker as any).miqData ?? marker.options;
  const { value, pending, hovered, isHeadQuarter, id } = miqData;
  const iconOpts = {
    text: !!+value ? abbrevNumber(value) : EMPTY_STRING,
    pending: !!pending,
    hovered: !hovered,
    isHeadQuarter,
    iconToUse: clipboardMarkers && clipboardMarkers.indexOf(id) !== -1 ? MapIcon.ClipboardMapIcon : null,
  };
  const icon = svgIconMaker(iconOpts, value == null || value === '' ? { width: 30, height: 40 } : null);
  marker.setIcon(icon);
  miqData.hovered = !hovered;
};
